<template>
	<p-card class="tw-text-center">
		<div class="tw-py-8">
			<span class="tw-m-0 text-info text-4xl">Bienvenida, <b>{{ sessionName }}</b></span>
			<span class="text-secondary tw-block text-2xl">{{ subTitle }}</span>
		</div>
	</p-card>
</template>

<script>
import PCard from '@/modules/shared/components/ui/Card/p-card';

export default {
	name: 'GreetingsHeader',
	components: { PCard },
	props: ['sessionName', 'subTitle'],
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/shared/components/business/GreetingsHeader.vue